<template>
  <div>
    <el-card class="box-card  min-h-screen">
      <div class="m-auto  text-center text-3xl">
        新建轮播图
      </div>
      <div class="mt-6">
        <el-form ref="form" :model="form" label-width="100px">
          <el-form-item label="轮播名称" class="w-2/4">
            <el-input v-model="form.siderbar_title"></el-input>
          </el-form-item>
          <el-form-item label="轮播图上传(1920×400)">
            <el-upload
              :action="uploadUrl"
              list-type="picture-card"
              :on-preview="handlePictureCardPreview"
              :on-remove="handleRemove"
              name="image"

              :limit="1"
              :on-change="handleChange"
              :on-success="handleSuccess"
              :on-error = "handleError"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :visible.sync="dialogVisible">
              <img width="100%" :src="dialogImageUrl" alt="" />
            </el-dialog>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitForm(form)">提交</el-button>
            <el-button @click="resetForm(form)">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>
<script>
import axios from "axios";

export default {
  mounted(){
    this.uploadUrl = this.$api.defaults.baseURL+'/Image/upload'

  },
  data() {
    return {
      uploadUrl:'',
      form: {
        siderbar_title: "",
        siderbar_img: "",
        publish_time: ""
      },
      uploadImgs:'',
      dialogImageUrl: "",
      dialogVisible: false
    };
  },
  methods: {
    handleSuccess(response){
      this.form.siderbar_img = this.$api.defaults.baseURL +  response.data.url
    },
    handleError(error){

    },
    submitForm(form) {
      form.publish_time = this.$funs.getTime();
      this.dialogImageUrl = true;
      axios.post('/siderbars',form).then(({ data }) => {
        if (data.code == 200) {
          this.$message({
            type: "success",
            message: "添加成功"
          });
          this.$router.push("/slideshowList");
        }
      });
    },
    resetForm(form) {
      this.form = {};
    },
    handleChange(file, fileList) {

    },

    handleRemove(file, fileList) {},
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/slideshow/addSlideshow.vue